import React from 'react'
import Cross from './assets/cross.svg'

type CloseButtonProps = {
  onClick: () => void
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => (
  <Cross onClick={onClick} />
)
